import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import {
  NamingConventionRoute,
  NamingConventionPathName,
} from '@/modules/ta/namingconvention/namingconvention.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${NamingConventionRoute.NAMINGCONVENTIONS}`,
      name: NamingConventionPathName.NAMINGCONVENTIONS,
      component: () =>
        import(
          /* webpackChunkName: "namingconventions-page" */ './pages/NamingConventionsPage.vue'
        ),
    },
    {
      path: `/${NamingConventionRoute.NAMINGCONVENTIONS}/new`,
      name: NamingConventionPathName.NAMINGCONVENTIONFORM_NEW,
      component: () =>
        import(
          /* webpackChunkName: "namingconvention-form-page" */ './pages/NamingConventionFormPage.vue'
        ),
      props: true,
    },
    {
      path: `/${NamingConventionRoute.NAMINGCONVENTIONS}/:id`,
      name: NamingConventionPathName.NAMINGCONVENTIONFORM,
      component: () =>
        import(
          /* webpackChunkName: "namingconvention-form-page" */ './pages/NamingConventionFormPage.vue'
        ),
      props: true,
    },
  ],
  Module.NAMINGCONVENTION
);
